var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmationModal',{staticClass:"delete-location-modal",class:{
    '--billing': _vm.subscribedBilling || _vm.delayedPeriod
  },attrs:{"title":"Delete location?","description":_vm.description,"confirmLabel":"Delete location","cancelLabel":"Cancel","loading":_vm.loading,"type":"delete"},on:{"close":_vm.onClose,"confirm":_vm.handleDeleteLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }